function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard-28") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "builder_calendar",
    "data-name": "builder calendar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58,10H57V8a4,4,0,0,0-8,0v2H43V8a4,4,0,0,0-8,0v2H29V8a4,4,0,0,0-8,0v2H15V8A4,4,0,0,0,7,8v2H6a6.006,6.006,0,0,0-6,6V54a6.006,6.006,0,0,0,6,6H58a6.006,6.006,0,0,0,6-6V16A6.006,6.006,0,0,0,58,10ZM51,8a2,2,0,0,1,4,0v6a2,2,0,0,1-4,0ZM37,8a2,2,0,0,1,4,0v6a2,2,0,0,1-4,0ZM23,8a2,2,0,0,1,4,0v6a2,2,0,0,1-4,0ZM9,8a2,2,0,0,1,4,0v6a2,2,0,0,1-4,0ZM6,12H7v2a4,4,0,0,0,8,0V12h6v2a4,4,0,0,0,8,0V12h6v2a4,4,0,0,0,8,0V12h6v2a4,4,0,0,0,8,0V12h1a4,4,0,0,1,4,4v6H2V16A4,4,0,0,1,6,12ZM58,58H6a4,4,0,0,1-4-4V24H62V54A4,4,0,0,1,58,58Z",
    style: {
      fill: "#202023"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5,46H45V43a10.013,10.013,0,0,0-9-9.949V30a1,1,0,0,0-1-1H29a1,1,0,0,0-1,1v3.051A10.013,10.013,0,0,0,19,43v3h-.5a3.5,3.5,0,0,0,0,7h27a3.5,3.5,0,0,0,0-7ZM21,43a8.008,8.008,0,0,1,7-7.931V38a1,1,0,0,0,2,0V31h4v7a1,1,0,0,0,2,0V35.069A8.008,8.008,0,0,1,43,43v3H21Zm24.5,8h-27a1.5,1.5,0,0,1,0-3h27a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#202023"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.01d772f039faa46917584b37eab226f1.svg";
export { ForwardRef as ReactComponent };